/**
 * Generated from PostcardCusco1Layout.fla
 */
export function PostcardCusco1Layout(this: IPostcardCusco1Layout) {
	const main = this.main;
	PostcardCusco1Layout_main.call(this.main);
	main.x = 1024;
	main.y = 768;
	if (main.onLayout) main.onLayout();
	return this;
}
export function PostcardCusco1Layout_main(this: IPostcardCusco1Layout_main) {
	const postcard = this.postcard;
	PostcardCusco1Layout_postcard.call(this.postcard);
	postcard.x = 0;
	postcard.y = 4.7;
	if (postcard.scale) postcard.scale.x = 0.633;
	if (postcard.scale) postcard.scale.y = 0.633;
	if (postcard.onLayout) postcard.onLayout();
	return this;
}
function PostcardCusco1Layout_postcard(this: IPostcardCusco1Layout_postcard) {
	const cardTransform = this.cardTransform;
	if (!cardTransform[0] && cardTransform.elementFactory) {
		cardTransform[0] = cardTransform.elementFactory(0,undefined);
	}
	if (cardTransform[0]) {
		PostcardCusco1Layout_cardTransform1.call(cardTransform[0] as IPostcardCusco1Layout_cardTransform1);
		cardTransform[0].x = -125.45;
		cardTransform[0].y = 371.05;
		cardTransform[0].width = 414.21;
		cardTransform[0].height = 519.20;
		if (cardTransform[0].onLayout) cardTransform[0].onLayout();
	}
	if (!cardTransform[1] && cardTransform.elementFactory) {
		cardTransform[1] = cardTransform.elementFactory(1,undefined);
	}
	if (cardTransform[1]) {
		PostcardCusco1Layout_cardTransform2.call(cardTransform[1] as IPostcardCusco1Layout_cardTransform2);
		cardTransform[1].x = 123.65;
		cardTransform[1].y = 343.8;
		cardTransform[1].width = 444.74;
		cardTransform[1].height = 557.47;
		if (cardTransform[1].onLayout) cardTransform[1].onLayout();
	}
	if (!cardTransform[2] && cardTransform.elementFactory) {
		cardTransform[2] = cardTransform.elementFactory(2,undefined);
	}
	if (cardTransform[2]) {
		PostcardCusco1Layout_cardTransform3.call(cardTransform[2] as IPostcardCusco1Layout_cardTransform3);
		cardTransform[2].x = -616.25;
		cardTransform[2].y = 105.65;
		cardTransform[2].width = 607.43;
		cardTransform[2].height = 761.40;
		if (cardTransform[2].onLayout) cardTransform[2].onLayout();
	}
	if (!cardTransform[3] && cardTransform.elementFactory) {
		cardTransform[3] = cardTransform.elementFactory(3,undefined);
	}
	if (cardTransform[3]) {
		PostcardCusco1Layout_cardTransform4.call(cardTransform[3] as IPostcardCusco1Layout_cardTransform4);
		cardTransform[3].x = -399.1;
		cardTransform[3].y = 293.75;
		cardTransform[3].width = 346.30;
		cardTransform[3].height = 434.07;
		if (cardTransform[3].onLayout) cardTransform[3].onLayout();
	}
	if (!cardTransform[4] && cardTransform.elementFactory) {
		cardTransform[4] = cardTransform.elementFactory(4,undefined);
	}
	if (cardTransform[4]) {
		PostcardCusco1Layout_cardTransform5.call(cardTransform[4] as IPostcardCusco1Layout_cardTransform5);
		cardTransform[4].x = 323.7;
		cardTransform[4].y = -379.4;
		cardTransform[4].width = 448.17;
		cardTransform[4].height = 561.77;
		if (cardTransform[4].onLayout) cardTransform[4].onLayout();
	}
	if (!cardTransform[5] && cardTransform.elementFactory) {
		cardTransform[5] = cardTransform.elementFactory(5,undefined);
	}
	if (cardTransform[5]) {
		PostcardCusco1Layout_cardTransform6.call(cardTransform[5] as IPostcardCusco1Layout_cardTransform6);
		cardTransform[5].x = 449;
		cardTransform[5].y = 126.05;
		cardTransform[5].width = 632.25;
		cardTransform[5].height = 792.51;
		if (cardTransform[5].onLayout) cardTransform[5].onLayout();
	}
	if (!cardTransform[6] && cardTransform.elementFactory) {
		cardTransform[6] = cardTransform.elementFactory(6,undefined);
	}
	if (cardTransform[6]) {
		PostcardCusco1Layout_cardTransform7.call(cardTransform[6] as IPostcardCusco1Layout_cardTransform7);
		cardTransform[6].x = 543.25;
		cardTransform[6].y = 380.7;
		cardTransform[6].width = 346.94;
		cardTransform[6].height = 434.88;
		if (cardTransform[6].onLayout) cardTransform[6].onLayout();
	}
	if (!cardTransform[7] && cardTransform.elementFactory) {
		cardTransform[7] = cardTransform.elementFactory(7,undefined);
	}
	if (cardTransform[7]) {
		PostcardCusco1Layout_cardTransform8.call(cardTransform[7] as IPostcardCusco1Layout_cardTransform8);
		cardTransform[7].x = -279.5;
		cardTransform[7].y = -44;
		cardTransform[7].width = 815.78;
		cardTransform[7].height = 1022.56;
		if (cardTransform[7].onLayout) cardTransform[7].onLayout();
	}
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[0]) {
		PostcardCusco1Layout_pieces8.call(items[0] as IPostcardCusco1Layout_pieces8);
		(items[0] as IPostcardCusco1Layout_pieces8).dependsOn = 0;
		(items[0] as IPostcardCusco1Layout_pieces8).outlineGlow = true;
		items[0].x = -279.2;
		items[0].y = -59.75;
		items[0].width = 877.00;
		items[0].height = 360.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		PostcardCusco1Layout_outlines8.call(items[1] as IPostcardCusco1Layout_outlines8);
		items[1].x = -303.6;
		items[1].y = -62.95;
		items[1].width = 829.00;
		items[1].height = 353.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		PostcardCusco1Layout_pieces5.call(items[2] as IPostcardCusco1Layout_pieces5);
		items[2].x = 336.55;
		items[2].y = -401.15;
		items[2].width = 307.00;
		items[2].height = 704.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		PostcardCusco1Layout_outlines5.call(items[3] as IPostcardCusco1Layout_outlines5);
		items[3].x = 328.35;
		items[3].y = -400.75;
		items[3].width = 290.00;
		items[3].height = 195.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[4]) {
		PostcardCusco1Layout_pieces3.call(items[4] as IPostcardCusco1Layout_pieces3);
		(items[4] as IPostcardCusco1Layout_pieces3).dependsOn = 0;
		(items[4] as IPostcardCusco1Layout_pieces3).outlineGlow = true;
		items[4].x = -605.5;
		items[4].y = 130.6;
		items[4].width = 586.00;
		items[4].height = 623.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,undefined);
	}
	if (items[5]) {
		PostcardCusco1Layout_outlines3.call(items[5] as IPostcardCusco1Layout_outlines3);
		items[5].x = -613.85;
		items[5].y = 111.65;
		items[5].width = 347.00;
		items[5].height = 589.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[6]) {
		PostcardCusco1Layout_pieces4.call(items[6] as IPostcardCusco1Layout_pieces4);
		(items[6] as IPostcardCusco1Layout_pieces4).dependsOn = 0;
		(items[6] as IPostcardCusco1Layout_pieces4).outlineGlow = true;
		items[6].x = -367.6;
		items[6].y = 317.1;
		items[6].width = 412.00;
		items[6].height = 407.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,undefined);
	}
	if (items[7]) {
		PostcardCusco1Layout_outlines4.call(items[7] as IPostcardCusco1Layout_outlines4);
		items[7].x = -398.85;
		items[7].y = 297.25;
		items[7].width = 246.00;
		items[7].height = 251.00;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,undefined);
	}
	if (items[8]) {
		PostcardCusco1Layout_pieces6.call(items[8] as IPostcardCusco1Layout_pieces6);
		items[8].x = 400.6;
		items[8].y = 196.2;
		items[8].width = 519.00;
		items[8].height = 586.00;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,undefined);
	}
	if (items[9]) {
		PostcardCusco1Layout_pieces1.call(items[9] as IPostcardCusco1Layout_pieces1);
		items[9].x = -90.6;
		items[9].y = 396.4;
		items[9].width = 311.00;
		items[9].height = 337.00;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,undefined);
	}
	if (items[10]) {
		PostcardCusco1Layout_outlines1.call(items[10] as IPostcardCusco1Layout_outlines1);
		items[10].x = -131.65;
		items[10].y = 398.35;
		items[10].width = 310.00;
		items[10].height = 337.00;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,undefined);
	}
	if (items[11]) {
		PostcardCusco1Layout_pieces2.call(items[11] as IPostcardCusco1Layout_pieces2);
		items[11].x = 110.3;
		items[11].y = 369.75;
		items[11].width = 219.99;
		items[11].height = 447.99;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,undefined);
	}
	if (items[12]) {
		PostcardCusco1Layout_outlines2.call(items[12] as IPostcardCusco1Layout_outlines2);
		items[12].x = 137.35;
		items[12].y = 335.65;
		items[12].width = 220.00;
		items[12].height = 448.00;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[13]) {
		PostcardCusco1Layout_pieces7.call(items[13] as IPostcardCusco1Layout_pieces7);
		(items[13] as IPostcardCusco1Layout_pieces7).dependsOn = 0;
		(items[13] as IPostcardCusco1Layout_pieces7).outlineGlow = true;
		items[13].x = 546.6;
		items[13].y = 394.45;
		items[13].width = 290.00;
		items[13].height = 218.00;
		if (items[13].onLayout) items[13].onLayout();
	}
	if (!items[14] && items.elementFactory) {
		items[14] = items.elementFactory(14,undefined);
	}
	if (items[14]) {
		PostcardCusco1Layout_outlines7.call(items[14] as IPostcardCusco1Layout_outlines7);
		items[14].x = 540.95;
		items[14].y = 394.6;
		items[14].width = 273.00;
		items[14].height = 217.00;
		if (items[14].onLayout) items[14].onLayout();
	}
	const shapes = this.shapes;
	if (!shapes[0] && shapes.elementFactory) {
		shapes[0] = shapes.elementFactory(0,undefined);
	}
	if (shapes[0]) {
		shapes[0] = [10.00,0.00];
	}
	if (!shapes[1] && shapes.elementFactory) {
		shapes[1] = shapes.elementFactory(1,undefined);
	}
	if (shapes[1]) {
		shapes[1] = [15.00,0.00];
	}
	if (!shapes[2] && shapes.elementFactory) {
		shapes[2] = shapes.elementFactory(2,undefined);
	}
	if (shapes[2]) {
		shapes[2] = [-442.50,401.20,-428.55,104.15,-502.40,87.25,-503.35,-15.20,-550.20,-55.20,-571.65,-196.70,-708.10,-196.30,-729.25,-70.55,-740.85,100.30,-800.00,115.55,-782.40,407.90,-607.80,414.80];
	}
	const background = this.background;
	PostcardCusco1Layout_background.call(this.background);
	background.x = 0;
	background.y = 0;
	background.width = 1790.00;
	background.height = 1325.00;
	if (background.onLayout) background.onLayout();
	const postcardOverlay = this.postcardOverlay;
	PostcardCusco1Layout_postcardOverlay.call(this.postcardOverlay);
	postcardOverlay.x = 0;
	postcardOverlay.y = 0;
	postcardOverlay.width = 1784.00;
	postcardOverlay.height = 1318.00;
	if (postcardOverlay.onLayout) postcardOverlay.onLayout();
	const postcardMask = this.postcardMask;
	postcardMask.push(11.60,-642.40,878.60,-641.10,869.70,11.90,875.65,626.30,29.70,629.25,-492.65,638.15,-880.20,652.65,-875.55,-47.50,-881.50,-655.95);
	return this;
}
function PostcardCusco1Layout_background(this: IPostcardCusco1Layout_background) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-cusco-1.png", 0.500, 0.500);
	return this;
}
function PostcardCusco1Layout_cardTransform5(this: IPostcardCusco1Layout_cardTransform5) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-cusco-1-5.png", 0.500, 0.501);
	return this;
}
function PostcardCusco1Layout_cardTransform8(this: IPostcardCusco1Layout_cardTransform8) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-cusco-1-8.png", 0.500, 0.501);
	return this;
}
function PostcardCusco1Layout_cardTransform3(this: IPostcardCusco1Layout_cardTransform3) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-cusco-1-3.png", 0.500, 0.501);
	return this;
}
function PostcardCusco1Layout_cardTransform4(this: IPostcardCusco1Layout_cardTransform4) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-cusco-1-4.png", 0.500, 0.501);
	return this;
}
function PostcardCusco1Layout_cardTransform1(this: IPostcardCusco1Layout_cardTransform1) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-cusco-1-1.png", 0.500, 0.501);
	return this;
}
function PostcardCusco1Layout_cardTransform2(this: IPostcardCusco1Layout_cardTransform2) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-cusco-1-2.png", 0.500, 0.501);
	return this;
}
function PostcardCusco1Layout_cardTransform6(this: IPostcardCusco1Layout_cardTransform6) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-cusco-1-6.png", 0.500, 0.501);
	return this;
}
function PostcardCusco1Layout_cardTransform7(this: IPostcardCusco1Layout_cardTransform7) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-cusco-1-7.png", 0.500, 0.501);
	return this;
}
function PostcardCusco1Layout_pieces8(this: IPostcardCusco1Layout_pieces8) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-cusco-1-8.png", 0.501, 0.500);
	return this;
}
function PostcardCusco1Layout_outlines8(this: IPostcardCusco1Layout_outlines8) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-cusco-1-8.png", 0.501, 0.501);
	return this;
}
function PostcardCusco1Layout_pieces5(this: IPostcardCusco1Layout_pieces5) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-cusco-1-5.png", 0.557, 0.138);
	return this;
}
function PostcardCusco1Layout_outlines5(this: IPostcardCusco1Layout_outlines5) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-cusco-1-5.png", 0.500, 0.503);
	return this;
}
function PostcardCusco1Layout_pieces3(this: IPostcardCusco1Layout_pieces3) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-cusco-1-3.png", 0.454, 0.504);
	return this;
}
function PostcardCusco1Layout_outlines3(this: IPostcardCusco1Layout_outlines3) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-cusco-1-3.png", 0.501, 0.501);
	return this;
}
function PostcardCusco1Layout_pieces4(this: IPostcardCusco1Layout_pieces4) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-cusco-1-4.png", 0.512, 0.609);
	return this;
}
function PostcardCusco1Layout_outlines4(this: IPostcardCusco1Layout_outlines4) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-cusco-1-4.png", 0.500, 0.502);
	return this;
}
function PostcardCusco1Layout_pieces6(this: IPostcardCusco1Layout_pieces6) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-cusco-1-6.png", 0.412, 0.589);
	return this;
}
function PostcardCusco1Layout_pieces1(this: IPostcardCusco1Layout_pieces1) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-cusco-1-1.png", 0.633, 0.499);
	return this;
}
function PostcardCusco1Layout_outlines1(this: IPostcardCusco1Layout_outlines1) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-cusco-1-1.png", 0.500, 0.501);
	return this;
}
function PostcardCusco1Layout_pieces2(this: IPostcardCusco1Layout_pieces2) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-cusco-1-2.png", 0.373, 0.578);
	return this;
}
function PostcardCusco1Layout_outlines2(this: IPostcardCusco1Layout_outlines2) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-cusco-1-2.png", 0.500, 0.500);
	return this;
}
function PostcardCusco1Layout_pieces7(this: IPostcardCusco1Layout_pieces7) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-cusco-1-7.png", 0.500, 0.500);
	return this;
}
function PostcardCusco1Layout_outlines7(this: IPostcardCusco1Layout_outlines7) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-cusco-1-7.png", 0.502, 0.502);
	return this;
}
function PostcardCusco1Layout_shapes2(this: IPostcardCusco1Layout_shapes2) {
	return this;
}
function PostcardCusco1Layout_shapes1(this: IPostcardCusco1Layout_shapes1) {
	return this;
}
function PostcardCusco1Layout_shapes3(this: IPostcardCusco1Layout_shapes3) {
	return this;
}
function PostcardCusco1Layout_postcardOverlay(this: IPostcardCusco1Layout_postcardOverlay) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-border.png", 0.500, 0.500);
	return this;
}
function PostcardCusco1Layout_postcardMask(this: IPostcardCusco1Layout_postcardMask) {
	return this;
}
interface IPostcardCusco1LayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IPostcardCusco1LayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IPostcardCusco1LayoutSprite extends IPostcardCusco1LayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IPostcardCusco1LayoutText extends IPostcardCusco1LayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IPostcardCusco1LayoutPolygon extends Array<number> {
}
interface IPostcardCusco1Layout {
	readonly main: IPostcardCusco1Layout_main;
}
interface IPostcardCusco1Layout_main extends IPostcardCusco1LayoutContainer {
	readonly postcard: IPostcardCusco1Layout_postcard;
}
interface IPostcardCusco1Layout_postcard extends IPostcardCusco1LayoutContainer {
	readonly cardTransform: IPostcardCusco1LayoutArray<IPostcardCusco1Layout_cardTransform1|IPostcardCusco1Layout_cardTransform2|IPostcardCusco1Layout_cardTransform3|IPostcardCusco1Layout_cardTransform4|IPostcardCusco1Layout_cardTransform5|IPostcardCusco1Layout_cardTransform6|IPostcardCusco1Layout_cardTransform7|IPostcardCusco1Layout_cardTransform8>;
	readonly items: IPostcardCusco1LayoutArray<IPostcardCusco1Layout_pieces8|IPostcardCusco1Layout_outlines8|IPostcardCusco1Layout_pieces5|IPostcardCusco1Layout_outlines5|IPostcardCusco1Layout_pieces3|IPostcardCusco1Layout_outlines3|IPostcardCusco1Layout_pieces4|IPostcardCusco1Layout_outlines4|IPostcardCusco1Layout_pieces6|IPostcardCusco1Layout_pieces1|IPostcardCusco1Layout_outlines1|IPostcardCusco1Layout_pieces2|IPostcardCusco1Layout_outlines2|IPostcardCusco1Layout_pieces7|IPostcardCusco1Layout_outlines7>;
	readonly shapes: IPostcardCusco1LayoutArray<IPostcardCusco1Layout_shapes1|IPostcardCusco1Layout_shapes2|IPostcardCusco1Layout_shapes3>;
	readonly background: IPostcardCusco1Layout_background;
	readonly postcardOverlay: IPostcardCusco1Layout_postcardOverlay;
	readonly postcardMask: IPostcardCusco1Layout_postcardMask;
}
interface IPostcardCusco1Layout_background extends IPostcardCusco1LayoutSprite {
}
interface IPostcardCusco1Layout_cardTransform5 extends IPostcardCusco1LayoutSprite {
}
interface IPostcardCusco1Layout_cardTransform8 extends IPostcardCusco1LayoutSprite {
}
interface IPostcardCusco1Layout_cardTransform3 extends IPostcardCusco1LayoutSprite {
}
interface IPostcardCusco1Layout_cardTransform4 extends IPostcardCusco1LayoutSprite {
}
interface IPostcardCusco1Layout_cardTransform1 extends IPostcardCusco1LayoutSprite {
}
interface IPostcardCusco1Layout_cardTransform2 extends IPostcardCusco1LayoutSprite {
}
interface IPostcardCusco1Layout_cardTransform6 extends IPostcardCusco1LayoutSprite {
}
interface IPostcardCusco1Layout_cardTransform7 extends IPostcardCusco1LayoutSprite {
}
interface IPostcardCusco1Layout_pieces8 extends IPostcardCusco1LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardCusco1Layout_outlines8 extends IPostcardCusco1LayoutSprite {
}
interface IPostcardCusco1Layout_pieces5 extends IPostcardCusco1LayoutSprite {
}
interface IPostcardCusco1Layout_outlines5 extends IPostcardCusco1LayoutSprite {
}
interface IPostcardCusco1Layout_pieces3 extends IPostcardCusco1LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardCusco1Layout_outlines3 extends IPostcardCusco1LayoutSprite {
}
interface IPostcardCusco1Layout_pieces4 extends IPostcardCusco1LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardCusco1Layout_outlines4 extends IPostcardCusco1LayoutSprite {
}
interface IPostcardCusco1Layout_pieces6 extends IPostcardCusco1LayoutSprite {
}
interface IPostcardCusco1Layout_pieces1 extends IPostcardCusco1LayoutSprite {
}
interface IPostcardCusco1Layout_outlines1 extends IPostcardCusco1LayoutSprite {
}
interface IPostcardCusco1Layout_pieces2 extends IPostcardCusco1LayoutSprite {
}
interface IPostcardCusco1Layout_outlines2 extends IPostcardCusco1LayoutSprite {
}
interface IPostcardCusco1Layout_pieces7 extends IPostcardCusco1LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardCusco1Layout_outlines7 extends IPostcardCusco1LayoutSprite {
}
interface IPostcardCusco1Layout_shapes2 extends IPostcardCusco1LayoutPolygon {
}
interface IPostcardCusco1Layout_shapes1 extends IPostcardCusco1LayoutPolygon {
}
interface IPostcardCusco1Layout_shapes3 extends IPostcardCusco1LayoutPolygon {
}
interface IPostcardCusco1Layout_postcardOverlay extends IPostcardCusco1LayoutSprite {
}
interface IPostcardCusco1Layout_postcardMask extends IPostcardCusco1LayoutPolygon {
}
